export default __webpack_public_path__ + "static/media/logo.a90c17f8.png";